import { split, map } from 'lodash/fp';
import { parseInt } from '../utils';

export default itemUniqKey => {
  const [
    inventoryItemId = null,
    inventoryLocationId = null,
    inventoryLocationZoneId = null
  ] = map(parseInt, split('_', itemUniqKey));

  return {
    inventoryItemId,
    inventoryLocationId,
    inventoryLocationZoneId
  };
};
